"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationContext = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TranslationContext = _react["default"].createContext({
  translationPrefix: null
});

exports.TranslationContext = TranslationContext;